document.addEventListener("click", e => {
  const path = e.composedPath();
  const selectorCheckout = `.AOV-CDMinimal__CheckoutButton, [name="checkout"], .upcart-checkout-button`;
  const target = path.find(el => {
    return el?.matches?.(selectorCheckout);
  });
  if ((e.target && e.target.closest(selectorCheckout)) || target) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
  }
}, 1); 